import { RouteItem } from '@eastcoal/router/types/route'

import { AUCTION_MOCK_PAGE_PATH } from './constants/path'

export const auctionMockRoute: RouteItem = {
  title: '模拟出价',
  hideInMenu: true,
  path: AUCTION_MOCK_PAGE_PATH,
  Component: () => import('./index')
}
